import env from "../../../environment"
export default {
    methods: {
        /**四舍五入保留两位小数 */
        fix(val, config = { empty: "--", len: 2, unit: "" }) {
            if (this.isnull(val)) return config.empty || "--";
            return parseFloat(val).toFixed(config.len || 2) + (config.unit || "");
        },
        /**向下取整保留小数位*/
        floorToFixed(num, decimal = 0) {
          if (isNaN(Number(num))) return 0;
          const multiple = Math.pow(10, decimal); // 10的N次方，用于放大数值
          return Math.floor(Number(num) * multiple) / multiple;
        },
       /**向上取整保留小数位*/
        ceilToFixed(num, decimal = 0) {
         if (isNaN(Number(num))) return 0;
         const multiple = Math.pow(10, decimal);
         return Math.round(Number(num) * multiple) / multiple;
        },
        /**空回boolearn */
        isnull(val) {
            if (val === undefined || val === "" || val === null || val.length < 1)
                return true;
            else return false;
        },
        /**空回替换 */
        repnull(val, config = { empty: "--", unit: "" }) {
            if (this.isnull(val)) return config.empty;
            if (config.unit) return val + config.unit;
            return val;
        },
        /**深拷贝 */
        docopy(val) {
            if (this.isnull(val)) return null;
            return JSON.parse(JSON.stringify(val));
        },
    },
}
